// antd components
import { Tooltip } from "antd";

//Props Validations
import PropTypes from "prop-types";

// mui icons
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";

const AppliedFiltersTooltip = ({ backendVariableLabel = {}, cfStoreData = {}, product = "" }) => {
    const _checkedFilter = backendVariableLabel.map((element) => {
        const _label = element.backendVariable;
        const displayLabelName = element.displayLabel;
        let checkedValues = cfStoreData[product]?.filters[_label]?.filter((ele) => ele.checked === true);
        return {
            labelName: _label,
            displayLabelName: displayLabelName,
            checkedValues: checkedValues ? checkedValues : [],
        };
    });
    const checkedFilter = _checkedFilter?.filter((datum) => datum.checkedValues.length !== 0);

    return (
        <Tooltip
            placement="bottomRight"
            color="white"
            overlayClassName="missing-filters-tooltip"
            overlayInnerStyle={{ padding: "0px 0px 1px 0px" }}
            align={{ offset: [70, 16] }}
            title={
                <div style={{ color: "#000000" }}>
                    <p style={{ backgroundColor: "#F5F5FF", padding: "10px 10px", fontSize: "1rem", fontWeight: "500" }}>Applied filters</p>
                    {checkedFilter.map((ele, i) => {
                        const displayLabel = ele.displayLabelName;
                        const values = ele.checkedValues.map((datum) => datum.label.replace(/ \|/g, ",").trim()).join(";");
                        return (
                            <div
                                key={i}
                                style={{ padding: "0px 10px 0px 10px" }}
                            >
                                <p style={{ margin: "2px 0" }}>
                                    <span
                                        className="my-0 text-bold-6"
                                        style={{
                                            fontSize: "0.7rem",
                                        }}
                                    >{`${displayLabel}: `}</span>
                                    <span style={{ fontWeight: "400", fontSize: "0.65rem", color: "#4d4d4d" }}>{`${values}`}</span>
                                </p>
                            </div>
                        );
                    })}
                </div>
            }
        >
            {checkedFilter.length ? (
                <DoNotDisturbOnIcon
                    sx={{ fontSize: "16px" }}
                    color="primary"
                />
            ) : (
                ""
            )}
        </Tooltip>
    );
};

// Typechecking props for the missing filters tooltip
AppliedFiltersTooltip.propTypes = {
    backendVariableLabel: PropTypes.object,
    cfStoreData: PropTypes.object,
    product: PropTypes.string,
};

export default AppliedFiltersTooltip;
